import React from 'react';
import { Link } from 'react-router-dom';
import { useData } from '../../context/DataContext';
import { getIcon } from '../../utils/iconMap';
import '../../styles/pages/Services.css';

const Services = () => {
  const { data, getServices, getUIText, loading, error } = useData();
  const services = getServices();
  const servicesUI = getUIText('services');
  const serviceImages = data?.images?.services || {};
  const backgroundImage = data?.images?.backgrounds?.services;
  const ctaBackgroundImage = data?.images?.backgrounds?.cta;

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
      </div>
    );
  }

  if (error) {
    return <div className="error-container"><p>Error loading data</p></div>;
  }

  const heroStyle = backgroundImage ? {
    '--page-hero-bg': `url(${backgroundImage})`
  } : {};

  const ctaStyle = ctaBackgroundImage ? {
    '--cta-bg': `url(${ctaBackgroundImage})`
  } : {};

  return (
    <main className="services-page mandala-bg">
      <section className={`page-hero${backgroundImage ? ' has-bg-image' : ''}`} style={heroStyle}>
        <div className="container">
          <h1 className="page-title">{servicesUI?.pageTitle || 'Our Services'}</h1>
          <p className="page-subtitle">{servicesUI?.pageSubtitle}</p>
        </div>
      </section>

      <section className="section services-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">{servicesUI?.mainSection?.title || 'What We Offer'}</h2>
            <p className="section-subtitle">{servicesUI?.mainSection?.subtitle}</p>
          </div>

          <div className="services-grid">
            {services.map((service) => (
              <div key={service.id} className="service-card">
                <div className="service-image">
                  {service.useImage ? (
                    <img
                      src={serviceImages[service.id] || service.image || 'https://via.placeholder.com/400x200'}
                      alt={service.title}
                    />
                  ) : (
                    <div className="service-icon-placeholder">
                      {getIcon(service.icon, { size: 64, className: 'service-icon' })}
                    </div>
                  )}
                </div>
                <div className="service-content">
                  <h3 className="service-title">{service.title}</h3>
                  <p className="service-description">{service.description}</p>
                  {service.features?.length > 0 && (
                    <ul className="service-features">
                      {service.features.slice(0, 3).map((feature, idx) => (
                        <li key={idx}>{feature}</li>
                      ))}
                    </ul>
                  )}
                  {service.learnMoreLink && (
                    <Link to={service.learnMoreLink} className="service-cta">
                      Learn More
                    </Link>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Process Section */}
      {data?.process?.length > 0 && (
        <section className="section process-section">
          <div className="container">
            <div className="section-header">
              <h2 className="section-title">{servicesUI?.processSection?.title || 'Our Process'}</h2>
              <p className="section-subtitle">{servicesUI?.processSection?.subtitle}</p>
            </div>
            <div className="process-grid">
              {data.process.map((step) => (
                <div key={step.step} className="process-step">
                  <div className="step-number">{step.step}</div>
                  <h3 className="step-title">{step.title}</h3>
                  <p className="step-description">{step.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* CTA Section */}
      <section className="section services-cta-section">
        <div className="container">
          <div className={`cta-content${ctaBackgroundImage ? ' has-bg-image' : ''}`} style={ctaStyle}>
            <h2 className="cta-title">{servicesUI?.cta?.title || 'Ready to Get Started?'}</h2>
            <p className="cta-subtitle">{servicesUI?.cta?.subtitle}</p>
            <Link to="/contact" className="cta-button">Contact Us</Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Services;
